import { Component, OnInit } from '@angular/core';
import { HopeUserVerificationService } from '../services/hope-user-verification.service';


@Component({
  selector: 'app-checkifuser',
  templateUrl: './checkifuser.component.html',
  styleUrls: ['./checkifuser.component.css']
})
export class CheckifuserComponent implements OnInit {

  constructor(private verificationService: HopeUserVerificationService) { }


  ngOnInit(): void {
    setTimeout(() => this.verificationService.verifyIsHopeAccount(), 1000);
  }

}
